import { a as j, c as R, j as V, b as N, i as _, g as q } from "./utils-CalFf5mA.mjs";
function G(S, e, k, c) {
  return S.params.createElements && Object.keys(c).forEach((d) => {
    if (!k[d] && k.auto === !0) {
      let s = j(S.el, `.${c[d]}`)[0];
      s || (s = R("div", c[d]), s.className = c[d], S.el.append(s)), k[d] = s, e[d] = s;
    }
  }), k;
}
function X(S) {
  let {
    swiper: e,
    extendParams: k,
    on: c,
    emit: d
  } = S;
  k({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  const s = (n) => (Array.isArray(n) ? n : [n]).filter((l) => !!l);
  function E(n) {
    let l;
    return n && typeof n == "string" && e.isElement && (l = e.el.querySelector(n), l) ? l : (n && (typeof n == "string" && (l = [...document.querySelectorAll(n)]), e.params.uniqueNavElements && typeof n == "string" && l.length > 1 && e.el.querySelectorAll(n).length === 1 && (l = e.el.querySelector(n))), n && !l ? n : l);
  }
  function C(n, l) {
    const o = e.params.navigation;
    n = s(n), n.forEach((a) => {
      a && (a.classList[l ? "add" : "remove"](...o.disabledClass.split(" ")), a.tagName === "BUTTON" && (a.disabled = l), e.params.watchOverflow && e.enabled && a.classList[e.isLocked ? "add" : "remove"](o.lockClass));
    });
  }
  function g() {
    const {
      nextEl: n,
      prevEl: l
    } = e.navigation;
    if (e.params.loop) {
      C(l, !1), C(n, !1);
      return;
    }
    C(l, e.isBeginning && !e.params.rewind), C(n, e.isEnd && !e.params.rewind);
  }
  function B(n) {
    n.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), d("navigationPrev"));
  }
  function y(n) {
    n.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), d("navigationNext"));
  }
  function T() {
    const n = e.params.navigation;
    if (e.params.navigation = G(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(n.nextEl || n.prevEl)) return;
    let l = E(n.nextEl), o = E(n.prevEl);
    Object.assign(e.navigation, {
      nextEl: l,
      prevEl: o
    }), l = s(l), o = s(o);
    const a = (t, i) => {
      t && t.addEventListener("click", i === "next" ? y : B), !e.enabled && t && t.classList.add(...n.lockClass.split(" "));
    };
    l.forEach((t) => a(t, "next")), o.forEach((t) => a(t, "prev"));
  }
  function x() {
    let {
      nextEl: n,
      prevEl: l
    } = e.navigation;
    n = s(n), l = s(l);
    const o = (a, t) => {
      a.removeEventListener("click", t === "next" ? y : B), a.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    n.forEach((a) => o(a, "next")), l.forEach((a) => o(a, "prev"));
  }
  c("init", () => {
    e.params.navigation.enabled === !1 ? $() : (T(), g());
  }), c("toEdge fromEdge lock unlock", () => {
    g();
  }), c("destroy", () => {
    x();
  }), c("enable disable", () => {
    let {
      nextEl: n,
      prevEl: l
    } = e.navigation;
    if (n = s(n), l = s(l), e.enabled) {
      g();
      return;
    }
    [...n, ...l].filter((o) => !!o).forEach((o) => o.classList.add(e.params.navigation.lockClass));
  }), c("click", (n, l) => {
    let {
      nextEl: o,
      prevEl: a
    } = e.navigation;
    o = s(o), a = s(a);
    const t = l.target;
    if (e.params.navigation.hideOnClick && !a.includes(t) && !o.includes(t)) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === t || e.pagination.el.contains(t))) return;
      let i;
      o.length ? i = o[0].classList.contains(e.params.navigation.hiddenClass) : a.length && (i = a[0].classList.contains(e.params.navigation.hiddenClass)), d(i === !0 ? "navigationShow" : "navigationHide"), [...o, ...a].filter((r) => !!r).forEach((r) => r.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const I = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), T(), g();
  }, $ = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), x();
  };
  Object.assign(e.navigation, {
    enable: I,
    disable: $,
    update: g,
    init: T,
    destroy: x
  });
}
function z(S) {
  return S === void 0 && (S = ""), `.${S.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Y(S) {
  let {
    swiper: e,
    extendParams: k,
    on: c,
    emit: d
  } = S;
  const s = "swiper-pagination";
  k({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (a) => a,
      formatFractionTotal: (a) => a,
      bulletClass: `${s}-bullet`,
      bulletActiveClass: `${s}-bullet-active`,
      modifierClass: `${s}-`,
      currentClass: `${s}-current`,
      totalClass: `${s}-total`,
      hiddenClass: `${s}-hidden`,
      progressbarFillClass: `${s}-progressbar-fill`,
      progressbarOppositeClass: `${s}-progressbar-opposite`,
      clickableClass: `${s}-clickable`,
      lockClass: `${s}-lock`,
      horizontalClass: `${s}-horizontal`,
      verticalClass: `${s}-vertical`,
      paginationDisabledClass: `${s}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let E, C = 0;
  const g = (a) => (Array.isArray(a) ? a : [a]).filter((t) => !!t);
  function B() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function y(a, t) {
    const {
      bulletActiveClass: i
    } = e.params.pagination;
    a && (a = a[`${t === "prev" ? "previous" : "next"}ElementSibling`], a && (a.classList.add(`${i}-${t}`), a = a[`${t === "prev" ? "previous" : "next"}ElementSibling`], a && a.classList.add(`${i}-${t}-${t}`)));
  }
  function T(a) {
    const t = a.target.closest(z(e.params.pagination.bulletClass));
    if (!t)
      return;
    a.preventDefault();
    const i = N(t) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === i) return;
      const r = e.realIndex, f = e.getSlideIndexByData(i), w = e.getSlideIndexByData(e.realIndex), A = (p) => {
        const L = e.activeIndex;
        e.loopFix({
          direction: p,
          activeSlideIndex: f,
          slideTo: !1
        });
        const v = e.activeIndex;
        L === v && e.slideToLoop(r, 0, !1, !0);
      };
      if (f > e.slides.length - e.loopedSlides)
        A(f > w ? "next" : "prev");
      else if (e.params.centeredSlides) {
        const p = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(parseFloat(e.params.slidesPerView, 10));
        f < Math.floor(p / 2) && A("prev");
      }
      e.slideToLoop(i);
    } else
      e.slideTo(i);
  }
  function x() {
    const a = e.rtl, t = e.params.pagination;
    if (B()) return;
    let i = e.pagination.el;
    i = g(i);
    let r, f;
    const w = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, A = e.params.loop ? Math.ceil(w / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (f = e.previousRealIndex || 0, r = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex != "undefined" ? (r = e.snapIndex, f = e.previousSnapIndex) : (f = e.previousIndex || 0, r = e.activeIndex || 0), t.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const p = e.pagination.bullets;
      let L, v, M;
      if (t.dynamicBullets && (E = V(p[0], e.isHorizontal() ? "width" : "height"), i.forEach((m) => {
        m.style[e.isHorizontal() ? "width" : "height"] = `${E * (t.dynamicMainBullets + 4)}px`;
      }), t.dynamicMainBullets > 1 && f !== void 0 && (C += r - (f || 0), C > t.dynamicMainBullets - 1 ? C = t.dynamicMainBullets - 1 : C < 0 && (C = 0)), L = Math.max(r - C, 0), v = L + (Math.min(p.length, t.dynamicMainBullets) - 1), M = (v + L) / 2), p.forEach((m) => {
        const h = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((b) => `${t.bulletActiveClass}${b}`)].map((b) => typeof b == "string" && b.includes(" ") ? b.split(" ") : b).flat();
        m.classList.remove(...h);
      }), i.length > 1)
        p.forEach((m) => {
          const h = N(m);
          h === r ? m.classList.add(...t.bulletActiveClass.split(" ")) : e.isElement && m.setAttribute("part", "bullet"), t.dynamicBullets && (h >= L && h <= v && m.classList.add(...`${t.bulletActiveClass}-main`.split(" ")), h === L && y(m, "prev"), h === v && y(m, "next"));
        });
      else {
        const m = p[r];
        if (m && m.classList.add(...t.bulletActiveClass.split(" ")), e.isElement && p.forEach((h, b) => {
          h.setAttribute("part", b === r ? "bullet-active" : "bullet");
        }), t.dynamicBullets) {
          const h = p[L], b = p[v];
          for (let P = L; P <= v; P += 1)
            p[P] && p[P].classList.add(...`${t.bulletActiveClass}-main`.split(" "));
          y(h, "prev"), y(b, "next");
        }
      }
      if (t.dynamicBullets) {
        const m = Math.min(p.length, t.dynamicMainBullets + 4), h = (E * m - E) / 2 - M * E, b = a ? "right" : "left";
        p.forEach((P) => {
          P.style[e.isHorizontal() ? b : "top"] = `${h}px`;
        });
      }
    }
    i.forEach((p, L) => {
      if (t.type === "fraction" && (p.querySelectorAll(z(t.currentClass)).forEach((v) => {
        v.textContent = t.formatFractionCurrent(r + 1);
      }), p.querySelectorAll(z(t.totalClass)).forEach((v) => {
        v.textContent = t.formatFractionTotal(A);
      })), t.type === "progressbar") {
        let v;
        t.progressbarOpposite ? v = e.isHorizontal() ? "vertical" : "horizontal" : v = e.isHorizontal() ? "horizontal" : "vertical";
        const M = (r + 1) / A;
        let m = 1, h = 1;
        v === "horizontal" ? m = M : h = M, p.querySelectorAll(z(t.progressbarFillClass)).forEach((b) => {
          b.style.transform = `translate3d(0,0,0) scaleX(${m}) scaleY(${h})`, b.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      t.type === "custom" && t.renderCustom ? (p.innerHTML = t.renderCustom(e, r + 1, A), L === 0 && d("paginationRender", p)) : (L === 0 && d("paginationRender", p), d("paginationUpdate", p)), e.params.watchOverflow && e.enabled && p.classList[e.isLocked ? "add" : "remove"](t.lockClass);
    });
  }
  function I() {
    const a = e.params.pagination;
    if (B()) return;
    const t = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length;
    let i = e.pagination.el;
    i = g(i);
    let r = "";
    if (a.type === "bullets") {
      let f = e.params.loop ? Math.ceil(t / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && f > t && (f = t);
      for (let w = 0; w < f; w += 1)
        a.renderBullet ? r += a.renderBullet.call(e, w, a.bulletClass) : r += `<${a.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${a.bulletClass}"></${a.bulletElement}>`;
    }
    a.type === "fraction" && (a.renderFraction ? r = a.renderFraction.call(e, a.currentClass, a.totalClass) : r = `<span class="${a.currentClass}"></span> / <span class="${a.totalClass}"></span>`), a.type === "progressbar" && (a.renderProgressbar ? r = a.renderProgressbar.call(e, a.progressbarFillClass) : r = `<span class="${a.progressbarFillClass}"></span>`), e.pagination.bullets = [], i.forEach((f) => {
      a.type !== "custom" && (f.innerHTML = r || ""), a.type === "bullets" && e.pagination.bullets.push(...f.querySelectorAll(z(a.bulletClass)));
    }), a.type !== "custom" && d("paginationRender", i[0]);
  }
  function $() {
    e.params.pagination = G(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const a = e.params.pagination;
    if (!a.el) return;
    let t;
    typeof a.el == "string" && e.isElement && (t = e.el.querySelector(a.el)), !t && typeof a.el == "string" && (t = [...document.querySelectorAll(a.el)]), t || (t = a.el), !(!t || t.length === 0) && (e.params.uniqueNavElements && typeof a.el == "string" && Array.isArray(t) && t.length > 1 && (t = [...e.el.querySelectorAll(a.el)], t.length > 1 && (t = t.filter((i) => _(i, ".swiper")[0] === e.el)[0])), Array.isArray(t) && t.length === 1 && (t = t[0]), Object.assign(e.pagination, {
      el: t
    }), t = g(t), t.forEach((i) => {
      a.type === "bullets" && a.clickable && i.classList.add(...(a.clickableClass || "").split(" ")), i.classList.add(a.modifierClass + a.type), i.classList.add(e.isHorizontal() ? a.horizontalClass : a.verticalClass), a.type === "bullets" && a.dynamicBullets && (i.classList.add(`${a.modifierClass}${a.type}-dynamic`), C = 0, a.dynamicMainBullets < 1 && (a.dynamicMainBullets = 1)), a.type === "progressbar" && a.progressbarOpposite && i.classList.add(a.progressbarOppositeClass), a.clickable && i.addEventListener("click", T), e.enabled || i.classList.add(a.lockClass);
    }));
  }
  function n() {
    const a = e.params.pagination;
    if (B()) return;
    let t = e.pagination.el;
    t && (t = g(t), t.forEach((i) => {
      i.classList.remove(a.hiddenClass), i.classList.remove(a.modifierClass + a.type), i.classList.remove(e.isHorizontal() ? a.horizontalClass : a.verticalClass), a.clickable && (i.classList.remove(...(a.clickableClass || "").split(" ")), i.removeEventListener("click", T));
    })), e.pagination.bullets && e.pagination.bullets.forEach((i) => i.classList.remove(...a.bulletActiveClass.split(" ")));
  }
  c("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const a = e.params.pagination;
    let {
      el: t
    } = e.pagination;
    t = g(t), t.forEach((i) => {
      i.classList.remove(a.horizontalClass, a.verticalClass), i.classList.add(e.isHorizontal() ? a.horizontalClass : a.verticalClass);
    });
  }), c("init", () => {
    e.params.pagination.enabled === !1 ? o() : ($(), I(), x());
  }), c("activeIndexChange", () => {
    typeof e.snapIndex == "undefined" && x();
  }), c("snapIndexChange", () => {
    x();
  }), c("snapGridLengthChange", () => {
    I(), x();
  }), c("destroy", () => {
    n();
  }), c("enable disable", () => {
    let {
      el: a
    } = e.pagination;
    a && (a = g(a), a.forEach((t) => t.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), c("lock unlock", () => {
    x();
  }), c("click", (a, t) => {
    const i = t.target, r = g(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && r && r.length > 0 && !i.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && i === e.navigation.nextEl || e.navigation.prevEl && i === e.navigation.prevEl)) return;
      const f = r[0].classList.contains(e.params.pagination.hiddenClass);
      d(f === !0 ? "paginationShow" : "paginationHide"), r.forEach((w) => w.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const l = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: a
    } = e.pagination;
    a && (a = g(a), a.forEach((t) => t.classList.remove(e.params.pagination.paginationDisabledClass))), $(), I(), x();
  }, o = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: a
    } = e.pagination;
    a && (a = g(a), a.forEach((t) => t.classList.add(e.params.pagination.paginationDisabledClass))), n();
  };
  Object.assign(e.pagination, {
    enable: l,
    disable: o,
    render: I,
    update: x,
    init: $,
    destroy: n
  });
}
function J(S) {
  let {
    swiper: e,
    extendParams: k,
    on: c,
    emit: d,
    params: s
  } = S;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, k({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !0,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let E, C, g = s && s.autoplay ? s.autoplay.delay : 3e3, B = s && s.autoplay ? s.autoplay.delay : 3e3, y, T = (/* @__PURE__ */ new Date()).getTime, x, I, $, n, l, o;
  function a(u) {
    !e || e.destroyed || !e.wrapperEl || u.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", a), p());
  }
  const t = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? x = !0 : x && (B = y, x = !1);
    const u = e.autoplay.paused ? y : T + B - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = u, d("autoplayTimeLeft", u, u / g), C = requestAnimationFrame(() => {
      t();
    });
  }, i = () => {
    let u;
    return e.virtual && e.params.virtual.enabled ? u = e.slides.filter((D) => D.classList.contains("swiper-slide-active"))[0] : u = e.slides[e.activeIndex], u ? parseInt(u.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, r = (u) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(C), t();
    let O = typeof u == "undefined" ? e.params.autoplay.delay : u;
    g = e.params.autoplay.delay, B = e.params.autoplay.delay;
    const D = i();
    !Number.isNaN(D) && D > 0 && typeof u == "undefined" && (O = D, g = D, B = D), y = O;
    const F = e.params.speed, H = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(F, !0, !0), d("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, F, !0, !0), d("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(F, !0, !0), d("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, F, !0, !0), d("autoplay")), e.params.cssMode && (T = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        r();
      })));
    };
    return O > 0 ? (clearTimeout(E), E = setTimeout(() => {
      H();
    }, O)) : requestAnimationFrame(() => {
      H();
    }), O;
  }, f = () => {
    e.autoplay.running = !0, r(), d("autoplayStart");
  }, w = () => {
    e.autoplay.running = !1, clearTimeout(E), cancelAnimationFrame(C), d("autoplayStop");
  }, A = (u, O) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(E), u || (o = !0);
    const D = () => {
      d("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", a) : p();
    };
    if (e.autoplay.paused = !0, O) {
      l && (y = e.params.autoplay.delay), l = !1, D();
      return;
    }
    y = (y || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - T), !(e.isEnd && y < 0 && !e.params.loop) && (y < 0 && (y = 0), D());
  }, p = () => {
    e.isEnd && y < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (T = (/* @__PURE__ */ new Date()).getTime(), o ? (o = !1, r(y)) : r(), e.autoplay.paused = !1, d("autoplayResume"));
  }, L = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const u = q();
    u.visibilityState === "hidden" && (o = !0, A(!0)), u.visibilityState === "visible" && p();
  }, v = (u) => {
    u.pointerType === "mouse" && (o = !0, !(e.animating || e.autoplay.paused) && A(!0));
  }, M = (u) => {
    u.pointerType === "mouse" && e.autoplay.paused && p();
  }, m = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", v), e.el.addEventListener("pointerleave", M));
  }, h = () => {
    e.el.removeEventListener("pointerenter", v), e.el.removeEventListener("pointerleave", M);
  }, b = () => {
    q().addEventListener("visibilitychange", L);
  }, P = () => {
    q().removeEventListener("visibilitychange", L);
  };
  c("init", () => {
    e.params.autoplay.enabled && (m(), b(), T = (/* @__PURE__ */ new Date()).getTime(), f());
  }), c("destroy", () => {
    h(), P(), e.autoplay.running && w();
  }), c("beforeTransitionStart", (u, O, D) => {
    e.destroyed || !e.autoplay.running || (D || !e.params.autoplay.disableOnInteraction ? A(!0, !0) : w());
  }), c("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        w();
        return;
      }
      I = !0, $ = !1, o = !1, n = setTimeout(() => {
        o = !0, $ = !0, A(!0);
      }, 200);
    }
  }), c("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !I)) {
      if (clearTimeout(n), clearTimeout(E), e.params.autoplay.disableOnInteraction) {
        $ = !1, I = !1;
        return;
      }
      $ && e.params.cssMode && p(), $ = !1, I = !1;
    }
  }), c("slideChange", () => {
    e.destroyed || !e.autoplay.running || (l = !0);
  }), Object.assign(e.autoplay, {
    start: f,
    stop: w,
    pause: A,
    resume: p
  });
}
export {
  J as Autoplay,
  X as Navigation,
  Y as Pagination
};
